module.exports = __webpack_public_path__ + "img/onlineCall-banner.43784406.jpg";